import React, { useState } from 'react';
import { mockData } from '../data/mockData';
import { ExternalLink, Play } from 'lucide-react';
import { Button } from './ui/button';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', ...new Set(mockData.gallery.map(item => item.category))];

  const filteredGallery = selectedCategory === 'All' 
    ? mockData.gallery 
    : mockData.gallery.filter(item => item.category === selectedCategory);

  const handleViewTour = (tourUrl) => {
    alert('360° tour viewer will open here. This is a placeholder for the interactive tour experience.');
  };

  return (
    <section id="gallery" className="relative py-32 bg-[#121212]">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            Tour <span className="text-[#00FFD1]">Gallery</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            Explore our portfolio of immersive 360° virtual tours across different industries.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 font-medium transition-all duration-400 ${
                selectedCategory === category
                  ? 'bg-[#00FFD1] text-black'
                  : 'bg-white/5 text-white/70 hover:bg-white/10 hover:text-white border border-white/10'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredGallery.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 transition-all duration-400 cursor-pointer"
              onClick={() => handleViewTour(item.tourUrl)}
            >
              {/* Image */}
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                
                {/* Play Icon Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                  <div className="w-16 h-16 bg-[#00FFD1] flex items-center justify-center">
                    <Play className="w-8 h-8 text-black fill-black" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <span className="text-[#00FFD1] text-sm font-semibold">{item.category}</span>
                <h3 className="heading-3 text-white mt-2 mb-3">{item.title}</h3>
                <Button 
                  className="btn-secondary w-full group/btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewTour(item.tourUrl);
                  }}
                >
                  View Tour
                  <ExternalLink className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Interactive Demo CTA */}
        <div className="mt-20 p-12 bg-gradient-to-r from-[#00FFD1]/10 to-transparent border border-[#00FFD1]/30 text-center">
          <h3 className="display-medium text-white mb-4">
            Experience a Live 360° Tour
          </h3>
          <p className="body-large text-white/85 mb-8 max-w-2xl mx-auto">
            See how immersive and interactive our virtual tours are. Navigate, explore, and experience spaces like never before.
          </p>
          <Button 
            className="btn-primary"
            onClick={() => handleViewTour('#demo')}
          >
            <Play className="w-5 h-5" />
            Launch Interactive Demo
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
